import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../../common/CmnContext';

function PracticeReserveSelectInstructorModalHead(props: any) {
  const isPc = useContext(cmnContext).isPc;

  const setIsDispModal = props.setIsDispModal;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: isPc? '10px 20px' : '10px',
    }}>
      <h4 style={{margin: '5px 0', fontWeight: 'bold'}}>講師を選択</h4>
      <button type="button" className="close" onClick={() => setIsDispModal(false)}>&times;</button>
    </div>
  );
}
  
export default PracticeReserveSelectInstructorModalHead;